import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Highlight from 'react-highlight';
import './QueryGroup.css'

class QueryGroup extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {data} = this.props;
        return (
            <div className="panel">
                <div className="panel-heading">
                    <span className="panel-title">{data.url}</span>
                    <div class="panel-heading-controls">
                        <span class="panel-heading-text">
                            <em>{data.userName || 'аноним'}</em>
                        </span>
                    </div>
                </div>
                <ul className="list-group">
                    {data.queries.map((query, i) =>
                        <li key={i} className="list-group-item">
                            <div className="clearfix">
                                <span>{query.recordsReturned} записи</span>
                                <span className="pull-right">{query.duration}мс</span>
                            </div>
                            <Highlight className="javascript">{query.body}</Highlight>
                        </li>)}
                </ul>
            </div>
        );
    }
}

export default QueryGroup;


// WEBPACK FOOTER //
// ./src/pages/Developers/MongoDbProfiler/components/QueryGroup.js